import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useRef, useState } from "react";
import Avatar from "components/Avatar";
import classNames from "classnames";
import { Tooltip } from "@mui/material";
import DownloadIcon from "assets/icons/download.svg?react";
import workspaceService from "api/workspaceService";
import { ENotificationType, notification } from "utils/notification";
import { formatPrice } from "utils/appPlans";

const PaymentsSummaryCard: FC<Props> = ({ item, workspaceId, year, month }) => {
  const rootRef = useRef(null);
  const refWrapper = useRef(null);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (downloading) return;
    setDownloading(true);

    try {
      const res = await workspaceService.downloadBilling({
        workspaceId,
        memberUserId: item.UserId,
        year,
        month,
      });

      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `wyciag_${year}_${String(month).padStart(2, "0")}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 30 * 1000);
    } catch {
      notification({
        type: ENotificationType.ERROR,
        title: "Wyciąg",
        text: "Nie udało się pobrać wyciągu.",
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className={styles.workerTab} ref={rootRef}>
      <div className={styles.data}>
        <div className={styles.name}>
          <div className={styles.name}>
            <Avatar className={styles.avatar} name={item.Label} size="small" />{" "}
            {item.Label}
          </div>
        </div>
        <div className={styles.edelivery}>
          {formatPrice(item.SubscriptionCost ?? 0)}
        </div>
        <div className={styles.nota}>{item.Nota}</div>
        <div className={styles.total}>{formatPrice(item.TotalCost ?? 0)}</div>

        {/* Status jest pojęciem per-okres (nagłówek grupy) — w wierszu członka pusta kolumna dla wyrównania. */}
        <div className={styles.status}></div>

        <div className={styles.more} ref={refWrapper}>
          <Tooltip title="Pobierz wyciąg">
            <div>
              <DownloadIcon
                onClick={handleDownload}
                className={classNames(styles.icon, downloading && styles.busy)}
              />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default PaymentsSummaryCard;
